export const sliceName = 'egeSubjects'

/** id базовой математики */
export const baseMathematicsId = 421

/** id иностранного языка */
export const foreignLanguageId = 148
